import { getApiUrlPath } from '@/models/constant'
import { GenericService } from '@/models/shared'
import { IPolicyRuleResponse } from './response'
import { IPolicyRuleRequest } from './request'


export class PolicyRuleFactory extends GenericService<IPolicyRuleRequest,
  IPolicyRuleResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath('PolicyRule')
    })
  }
}

